
import { useDispatch } from 'react-redux';
import { Card, Button, Row, Col } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import { closeWishlist } from '../redux/cartWishSlice';
import { BsHeart, BsHeartFill, BsXLg } from "react-icons/bs";
import useProductActions from '../utils/productThanos';

const WishlistSidebar = () => {
  const dispatch = useDispatch();
  const {wishlistItems,isAddedW,isWishlistOpen, handleAddToCartFromWishlist,handleWishlistToggle,handleClearWish } = useProductActions(); 

  if (!isWishlistOpen) return null;

  return (
    <div className={`wishlist-sidebar ${isWishlistOpen ? 'open' : ''}`}>
      <div className="wishlist-sidebar-header cartwishHeader">
        <h2>Your Wishlist</h2>
        <button onClick={() => dispatch(closeWishlist())}><BsXLg /></button>
      </div>
      {wishlistItems.length === 0 ? (
        <div className='emptyCart'>
         <img src='../../imgs/Shopping_Cart.gif' alt="Empty Wishlist" />
         <p>Your wishlist is empty</p>
       </div>
      ) : (
        <Row>
          <button onClick={handleClearWish}>
            Clear Your Wish
          </button>
          {wishlistItems.map((product) => (
            <Col md={6} xs={6} key={product.id} className="mb-4">
              <Card className="productCard d-flex">
                <Card.Img variant="top" src={product.image} />
                <Card.Body>
                  <Card.Title>{product.name}</Card.Title>
                  <Card.Text>${product.price.toFixed(2)}</Card.Text>
                  <Button
                    variant="primary"
                    onClick={() => handleAddToCartFromWishlist(product)}
                  >
                    Add to Cart
                  </Button>
                 
                  <button 
                  className={`wishlist-btn ${isAddedW ? 'wishlisted' : ''}`} 
                  onClick={()=>handleWishlistToggle(product)}
                >
                  {isAddedW ? <BsHeartFill /> : <BsHeart />} {isAddedW ? 'Wishlisted' : 'Remove'}
                </button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default WishlistSidebar;
